import { Injector } from '@angular/core';
import { isEmpty, pull } from '@sama/micro-dash';
import { isSensorFusionOutput } from '../../../../../cross-team-shared/misc-utils/output-utils';
import { AbstractOutput } from '../../../../../team-apis/otterdam/outputs/output';
import { OutputInfo } from '../../../../h3ml/state/output-info';
import { FeatureFlagService } from '../../../../shared/misc-services/feature-flag.service';
import { TabName } from '../state/layers/transient-shape-layer-state';
import { BulkRemoveKeyframesOptions } from '../utils/bulk-remove-frame-annotations.service';
import { FusionMinion } from './fusion-minion';

export class ShapeFusionManager {
  minions: FusionMinion[] = [];
  protected featureFlagService: FeatureFlagService;

  constructor(
    public output: AbstractOutput,
    injector: Injector,
  ) {
    this.featureFlagService = injector.get(FeatureFlagService);
  }

  registerMinion(minion: FusionMinion) {
    this.minions.push(minion);
  }

  unregisterMinion(minion: FusionMinion) {
    pull(this.minions, minion);
  }

  openTagEditor(index: number, outputId: number) {
    this.minions.forEach((minion) => {
      if (minion.getOutputId() !== outputId) {
        minion.openTagEditor(index, undefined, false);
      }
    });
  }

  closeTagEditor(outputId: number, index?: number) {
    this.minions.forEach((minion) => {
      if (minion.getOutputId() !== outputId) {
        minion.closeTagEditor(undefined, index, false);
      }
    });
  }

  // eslint-disable-next-line max-params-unless-injectable -- keeps same signatures as the method in tagService
  updateTag(
    outputInfo: OutputInfo,
    shapeIndex: number,
    frameNumber: number,
    wasOutputVisible: boolean,
    outputId: number,
  ) {
    if (!this.isFusedAnswerOption(outputInfo.output.name)) {
      return;
    }

    this.minions.forEach((minion) => {
      if (minion.getOutputId() !== outputId) {
        minion.updateTag(outputInfo, shapeIndex, frameNumber, wasOutputVisible);
      }
    });
  }

  removeKeyframe(
    frameNumber: number,
    outputInfo: OutputInfo,
    shapeIndex: number,
    outputId: number,
  ) {
    if (!this.isFusedAnswerOption(outputInfo.output.name)) {
      return;
    }

    this.minions.forEach((minion) => {
      if (minion.getOutputId() !== outputId) {
        minion.removeKeyframe(frameNumber, outputInfo, shapeIndex, false);
      }
    });
  }

  switchTagEditorTab(name: TabName, shapeIndex: number, outputId: number) {
    this.minions.forEach((minion) => {
      if (minion.getOutputId() !== outputId) {
        minion.switchTagEditorTab(name, shapeIndex, false);
      }
    });
  }

  bulkRemoveKeyframes(options: BulkRemoveKeyframesOptions, outputId: number) {
    this.minions.forEach((minion) => {
      if (minion.getOutputId() !== outputId) {
        minion.removeDynamicTags(options, this.getFusedAnswerOptions());
      }
    });
  }

  isFusedAnswerOption(outputName: string) {
    return !!this.getFusedAnswerOptions().find(
      (output) => output.name === outputName,
    );
  }

  hasFusedAnswerOptions() {
    return !isEmpty(this.getFusedAnswerOptions());
  }

  private getFusedAnswerOptions() {
    if (isSensorFusionOutput(this.output)) {
      return this.output.answer_options;
    }
    return [];
  }
}
